import { Observable } from 'rxjs';
import { AppEndpoints } from '../app.endpoints';
import { HttpService } from '@ibank-globals/http';

export interface IBlockUserRequest {
	userName: string;
	vat: string;
}

export interface IBlockUserResponse {
	success: boolean;
}

export class BlockUser {
	public static BlockUser(request: IBlockUserRequest): Observable<IBlockUserResponse> {
		return HttpService.post<IBlockUserResponse>(AppEndpoints.blockUser, request);
	}
}
